import React from 'react';

import SkeletonLine from '../../../../../components/Skeleton/SkeletonLine';
import SkeletonSlash from '../../../../../components/Skeleton/SkeletonSlash';

import Icon from '../../../../../../../components/Icon';

const baseCls = 'checkout-billinfo';

const BillInfoSkeleton = () => (
  <div className={`${baseCls}__skeleton ${baseCls}__block`}>
    <SkeletonLine style={{ width: 170, marginTop: 7, marginBottom: 32 }} />
    <div className="flex">
      <div className="flex">
        <SkeletonSlash style={{ width: 22, marginLeft: -6 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22 }} />
        <SkeletonSlash style={{ width: 22, marginLeft: 10 }} />
        <SkeletonSlash style={{ width: 22 }} />
      </div>
      <div className="flex flex-column" style={{ marginLeft: 37 }}>
        <SkeletonLine style={{ width: 192, marginTop: -7, marginBottom: 13 }} />
        <div className="flex">
          <SkeletonLine style={{ width: 123 }} />
          <Icon type="clock" />
        </div>
      </div>
    </div>
    <div className="flex flex-column">
      <SkeletonLine style={{ width: 172, marginTop: 12, marginBottom: 18 }} />
      <SkeletonLine style={{ width: 158 }} />
    </div>
  </div>
);

export default BillInfoSkeleton;
